// src/components/ui/ThemeToggle.tsx
import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '1px solid var(--color-border)',
        backgroundColor: 'var(--color-surface)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        color: 'var(--color-primary)',
        position: 'relative',
        overflow: 'hidden'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-hover-bg)';
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-surface)';
        e.currentTarget.style.transform = 'scale(1)';
      }}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {/* Animated Icon Container */}
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          transform: theme === 'dark'
            ? 'translate(-50%, -50%) rotate(0deg) scale(1)'
            : 'translate(-50%, -50%) rotate(180deg) scale(0)',
          opacity: theme === 'dark' ? 1 : 0
        }}
      >
        <Sun size={20} />
      </div>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          transform: theme === 'light'
            ? 'translate(-50%, -50%) rotate(0deg) scale(1)'
            : 'translate(-50%, -50%) rotate(-180deg) scale(0)',
          opacity: theme === 'light' ? 1 : 0
        }}
      >
        <Moon size={20} />
      </div>
    </button>
  );
};
